import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Route, Routes } from "react-router-dom";
import "./static/style/index.css";
import LiveRate from "./page/stock/live";
import LayoutComp from "./layout/layout";
import Bank from "./page/bank/bank";
import ContactUs from "./page/contactus/contactus";
import Redirect from "./page/redirect/Redirect";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import MemberLogin from "./page/MemberLogin/MemberLogin";

const firebaseConfig = {
  apiKey: "AIzaSyDlECTGROm8ZczM7eKWEjs3LeDH6Wz0WJM",
  authDomain: "mahalaxmi-21e01.firebaseapp.com",
  projectId: "mahalaxmi-21e01",
  storageBucket: "mahalaxmi-21e01.appspot.com",
  messagingSenderId: "897540562315",
  appId: "1:897540562315:web:1f4114578f175e7132238e",
  measurementId: "G-2VLCDE9FBV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  return (
    <div>
      <Routes>
        {/* backup */}
        {/* <Route path="/" element={<LayoutComp />}>
          <Route index element={<LiveRate />} />
          <Route path="/bank" element={<Bank />} />
          <Route path="/contact" element={<ContactUs />} />
        </Route> */}

        {/* main */}

        {localStorage.getItem("isLoggedIn") ? (
          <Route path="/" element={<LayoutComp />}>
            <Route index element={<LiveRate />} />
            <Route path="/bank" element={<Bank />} />
            <Route path="/contact" element={<MemberLogin />} />
          </Route>
        ) : (
          <Route path="/" element={<ContactUs />} />
        )}

        {/* main websie which will redirect */}

        {/* major change */}
        {/* {localStorage.getItem("isLoggedIn") ? (
          <Route path="/" element={<Redirect />}>
            <Route index element={<Redirect />} />
            <Route path="/bank" element={<Bank />} />
            <Route path="/contact" element={<ContactUs />} />
          </Route>
        ) : (
          <Route path="/" element={<ContactUs />} />
        )} */}
      </Routes>
    </div>
  );
}

export default App;
